export default __webpack_public_path__ + "static/media/ic_lif3_30.8d692f89.svg";